import BaseRequest from './index'

class CardService extends BaseRequest {
  constructor() {
    super()
    this.bindMethods()
  }

  bindMethods() {
    this.getMyCards = this.getMyCards.bind(this)
    this.deleteCard = this.deleteCard.bind(this)
    this.addCards = this.addCards.bind(this)
  }

  async getMyCards<T>(): Promise<T> {
    return await this.api.get('/user/card')
  }

  async deleteCard(id: string) {
    return await this.api.delete(`/user/card/${id}/delete`)
  }
  // async addMyCards<T>(): Promise<T> {
  //   return await this.api.post('user/card/create')
  // }
  async addCards() {
    return await this.api.post('/user/card/create')
  }
}

const cardService = new CardService()

export default cardService
